import { Image } from "react-bootstrap"
import under_progress2 from "../../Utils/assets/img/under_progress2.png"

const UnderProgress = () => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center m-5">
      <Image
        src={under_progress2}
        className="img-fluid"
        style={{
          height: "250px",
          width: "auto",
          objectFit: "contain",
        }}
      />
      <h4 className="text-center mt-3">WORK UNDER PROGRESS ...</h4>
    </div>
  )
}

export default UnderProgress
